// Moderazione lato client (feedback immediato). L'autorità resta il server.
const LEET = { "0": "o", "1": "i", "3": "e", "4": "a", "5": "s", "7": "t", "@": "a", "€": "e", "$": "s" };

const PROFANITY = [
  "cazzo", "cazz", "caxxo", "cax", "merda", "merd", "stronzo", "stronz", "stronza",
  "troia", "troie", "puttana", "puttan", "putt", "vaffanculo", "vaffa", "vaff",
  "fanculo", "culo", "coglione", "coglion", "cogliona", "minchia", "minkia", "minch",
  "mignotta", "bastardo", "bastarda", "pezzodimerda", "schifodipersona", "leccaculo",
];
const SACRED = ["dio", "iddio", "gesu", "cristo", "madonna", "maria", "signore"];
const OFFENSIVE = ["porco", "porca", "cane", "maiale", "boia", "bastardo", "bastarda", "merda", "puttana", "troia", "ladro", "schifoso"];
const THREATS = [
  "ti ammazzo", "ti uccido", "vi ammazzo", "vi uccido", "devi morire", "spero che muori",
  "spero che tu muoia", "vi odio tutti", "fai schifo", "sei una merda", "sei uno schifo",
  "ti rovino la vita", "ti distruggo", "ti spacco", "vi odio",
];
const SELF_HARM = [
  "voglio morire", "mi voglio uccidere", "mi ammazzo", "non voglio piu vivere",
  "la faccio finita", "farla finita", "voglio farla finita", "mi taglio", "suicidio",
  "suicidarmi", "addio per sempre", "uccidermi", "ammazzarmi",
];
const LINK_SUBSTR = [
  "http://", "https://", "www.", "t.me", "wa.me", "bit.ly", "tinyurl", "linktree",
  "telegram", "instagram.com", "facebook.com", "tiktok.com", "youtube.com", "x.com",
  "twitter.com", "onlyfans",
];
const TLD_RE = /[a-z0-9-]+\.(com|it|net|org|io|co|eu|me|link|bio|site|online|store|app)\b/;
const EMAIL_RE = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/;
const PHONE_LONG_RE = /\d{7,}/;
const PHONE_SEP_RE = /\+?\d[\d\s.\-]{5,}\d/g;

const SELF_HARM_MSG =
  "Questo messaggio sembra contenere un dolore importante. Per sicurezza non possiamo pubblicarlo automaticamente. Se sei in pericolo o pensi di farti del male, contatta subito una persona vicina o i servizi di emergenza.";
const GENERIC_MSG = "Il messaggio contiene elementi non consentiti. Modificalo prima di continuare.";
const SIGN_MSG = "La firma contiene elementi non consentiti. Modificala prima di continuare.";

const stripAccents = (s) => s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
const compress = (s) => s.replace(/(.)\1{2,}/g, "$1");

const normalize = (text) => {
  let t = stripAccents(text.toLowerCase());
  t = t.replace(/./g, (c) => LEET[c] || c);
  let spaced = t.replace(/[^a-z0-9]+/g, " ").trim().replace(/\s+/g, " ");
  spaced = spaced ? spaced.split(" ").map(compress).join(" ") : "";
  const compact = compress(t.replace(/[^a-z0-9]+/g, ""));
  return { spaced, compact };
};

const checkContacts = (raw) => {
  const low = raw.toLowerCase();
  if (EMAIL_RE.test(low)) return "blocked_email";
  if (LINK_SUBSTR.some((s) => low.includes(s)) || TLD_RE.test(low)) return "blocked_link";
  if (PHONE_LONG_RE.test(raw)) return "blocked_phone";
  const matches = raw.match(PHONE_SEP_RE) || [];
  for (const m of matches) {
    if (m.replace(/\D/g, "").length >= 7) return "blocked_phone";
  }
  return null;
};

const checkWords = (spaced, compact) => {
  if (PROFANITY.some((p) => compact.includes(p))) return "blocked_profanity";
  for (const s of SACRED) {
    for (const o of OFFENSIVE) {
      if (compact.includes(s + o) || compact.includes(o + s)) return "blocked_blasphemy";
    }
  }
  return null;
};

// Ritorna { ok, type, message }. type: null | 'self_harm' | 'blocked'
export const moderateClient = (text) => {
  const t = (text || "").trim();
  if (!t) return { ok: true };
  const c = checkContacts(t);
  if (c) return { ok: false, type: "blocked", message: GENERIC_MSG };
  const { spaced, compact } = normalize(t);
  if (SELF_HARM.some((p) => spaced.includes(p))) return { ok: false, type: "self_harm", message: SELF_HARM_MSG };
  if (THREATS.some((p) => spaced.includes(p))) return { ok: false, type: "blocked", message: GENERIC_MSG };
  if (checkWords(spaced, compact)) return { ok: false, type: "blocked", message: GENERIC_MSG };
  return { ok: true };
};

export const moderateSignatureClient = (firma) => {
  const f = (firma || "").trim();
  if (!f) return { ok: true };
  if (f.length > 30) return { ok: false, message: SIGN_MSG };
  if (checkContacts(f)) return { ok: false, message: SIGN_MSG };
  const { spaced, compact } = normalize(f);
  if (checkWords(spaced, compact)) return { ok: false, message: SIGN_MSG };
  if (THREATS.some((p) => spaced.includes(p))) return { ok: false, message: SIGN_MSG };
  return { ok: true };
};
